module.exports = __webpack_public_path__ + "img/zzkf3.6e710be4.jpg";